import { Grid } from '@mui/material';
import { useGetProductsWithVariations } from 'src/hooks';
import {
  IProductVariation,
  IProductVariationFlavor,
  IProductVariationSize,
} from 'src/interfaces';

export const TemplateVariations = ({
  nameOverride,
  productVariation,
  productVariationTypes,
  productVariationFlavors,
  renderItem,
}: {
  nameOverride: string;
  productVariation?: IProductVariation | null;
  productVariationTypes: IProductVariationSize[];
  productVariationFlavors: IProductVariationFlavor[];
  renderItem: (value: string, order: number) => React.ReactNode;
}) => {
  const templateMappingVariations = useGetProductsWithVariations(
    [
      `product_code.list=${productVariation?.variation_template?.variations
        .map((variation: any) => variation.product_code)
        .join('|')}`,
    ],
    { enabled: !!productVariation?.variation_template },
  );

  return (
    <Grid item xs container direction={'row'} spacing={2}>
      {productVariation?.variation_template?.variations.map((v) => {
        const variation = templateMappingVariations.data?.find(
          (item) => item.product_code === v.product_code,
        );
        const variationSize = productVariationTypes.find(
          (item) => item.id === variation?.product_variation_size_id,
        );
        const variationFlavor = productVariationFlavors.find(
          (item) => item.id === variation?.product_variation_flavor_id,
        );
        const isSameVariation =
          productVariation?.product_code === variation?.product_code;
        const value = [
          variation?.product_code,
          isSameVariation && nameOverride ? nameOverride : variation?.name,
          variationSize?.name,
          variationFlavor?.name,
        ]
          .filter(Boolean)
          .join(' - ');

        return (
          <Grid item xs key={v.order}>
            {renderItem(value, v.order)}
          </Grid>
        );
      })}
    </Grid>
  );
};
